<template>
  <div>
    <div class="chat-container" ref="chatList">
      <div class="chat-box">
        <div class="chat-list" @click="onChatClick">
          <div v-for="(msg, index) in messages" :key="msg._id || index"
            :class="['chat-msg']">
            <div class="chat-bubble">
             
              <!-- AI：Markdown -> HTML -->
              <template>

                <div v-html="mdToHtml(getMsg(msg))"></div>
                <div v-if="msg.loading" class="loading-dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>

    </div>


    <!-- 输入框 -->
    <div class="bottom-container">
      <div class="chat-input">
        <input type="text" border="none" v-model="draft" @keyup.enter="handleSend" />
      </div>
    </div>

  </div>
</template>

<script>
// import VConsole from 'vconsole'

// new VConsole()
import ajax from '../api/ajax';
import { getQueryString } from '../api/restapi';
import marked from 'marked';
import DOMPurify from 'dompurify';
import { v4 as uuidv4 } from "uuid"; // 用于生成唯一 _id
export default {
  name: "AIGodownChat",
  data() {
    return {
      pageContent: "",
      loadStatus: true,
      content: '',
      patientId: '',
      eventSource: null,
      draft: "",
      messages: [],
      currentAnswer: null,
      currentId: null,
      dataId: null,
      contentBuffer: "",
      sendMsg: "",
      savedScrollTop: 0,
      loading: false,
      autoScrollEnabled: true,
      firstLoadDone: false, // 标记是否首次加载完成
    };
  },
  activated() {
    this.$nextTick(() => {
      const container = this.$refs.chatList;
      if (!container) return;

      // 恢复用户之前滚动的位置
      if (this.savedScrollTop) {
        container.scrollTop = this.savedScrollTop;
        console.log("恢复位置", this.savedScrollTop);
      }
    });
  },

  deactivated() {
    console.log("保存位置", this.savedScrollTop);
  },
  created() {
    let href = decodeURIComponent(window.location.href);
    let serach = href.split('?')[1];
    let paramsArr = serach.split('&');
    this.id = getQueryString('id');
    let params = {};
    for (const str of paramsArr) {
      let param = str.split('=');
      params[param[0]] = param[1]
    }
    this.text = params.text;
    this.type = params.type;
        
    document.title = params.text;

    console.log("this.text", params)

    setTimeout(() => {
      this.handleSend();
    }, 500);
    // this.handleSend();
    // this.getHistoryList();
  },
  mounted() {
    // this.id = getQueryString('id');
    window.addEventListener("resize", this.handleResize);

    // this.toConnect()
    // this.getSignature();

  },

  methods: {

    onChatClick(event) {
      const citeEl = event.target.closest(".cite-tag");
      if (citeEl) {
        const citeId = citeEl.dataset.cite;
        const dataId = citeEl.dataset.dataid;
        console.log("citeEl",citeEl);
        this.$router.push({
          path: '/nutritionToolView',
          query: {
            citeId: citeId,
            dataId: dataId,
            chatId: this.id,
            chatType: this.type
          }
        });

      }
    },
    send() {
      // 检查微信JS-SDK是否已加载
      if (typeof window.wx === 'undefined') {
        console.error('微信JS-SDK未加载');
        return;
      }

      window.wx.ready(() => {
        window.wx.chooseImage({
          count: 1,
          sizeType: ['original', 'compressed'],
          sourceType: ['album', 'camera'],
          success: (res) => {
            let localIds = res.localIds;
            console.log("localIds", localIds);
            // 在这里可以添加处理选中图片的逻辑
          },
          fail: (error) => {
            console.error('选择图片失败:', error);
          }
        });
      });

      window.wx.error((error) => {
        console.error('微信JS-SDK配置失败:', error);
      });
    },


    getSignature() {
      ajax
        .Post({
          url: '/api/third/wx/getJsSdkAuthSignature',
          data: { appId: 'wx07f3a380dbc07549', type: 0, url: window.location.href }
        }).then(({ data: { data } }) => {
          window.wx.config({
            debug: false,
            appId: 'wx07f3a380dbc07549',
            timestamp: data.timestamp,
            nonceStr: data.nonceStr,
            signature: data.signature,
            jsApiList: ['miniProgram', 'chooseImage']
          });
          // 添加配置成功的回调
          window.wx.ready(() => {
            console.log('微信JS-SDK配置成功');
          });

          // 添加配置失败的回调
          window.wx.error((error) => {
            console.error('微信JS-SDK配置失败:', error);
          });
        }).catch(error => {
          console.error('获取微信签名失败:', error);
        });

    },
    // 连接 SSE 服务
    toConnect() {
      if (this.eventSource) {
        this.eventSource.close();
      }
      // 创建 SSE 连接
      this.eventSource = new EventSource(`/api/ai/hlxj/sse/connected?clientId=${this.id}`);
      console.log("this.eventSource", this.eventSource)
      // 监听服务器发送的消息
      this.eventSource.onmessage = this.handleEventMessage

      this.eventSource.onopen = () => {
        console.log('SSE已连接')
      };
      setTimeout(() => {
        this.getContent()
      }, 1200);
      // 处理错误
      this.eventSource.onerror = (error) => {
        console.error('SSE error:', error);
        this.eventSource.close();
      };

    },

    getContent() {
      console.log("this.draft", this.draft)
      ajax
        .Post({
          url: '/api/ai/hlxj/sse/sendFastGptMsg',
          data: {
            chatId: this.id,
            dataId: this.dataId,
            chatType:'yyzk',
            prompt: `${this.type}_${this.sendMsg || this.text}`
          }
        })

    },
    // 处理发送消息
    handleSend() {
      this.loadStatus = false

      this.sendMsg = this.draft;

      document.title = this.draft;
      this.messages = []
      let dataId = uuidv4().replace(/-/g, "");
      this.dataId = dataId


      let _id = uuidv4().replace(/-/g, "");
      this.currentId = _id;
      this.loading = true
      // 第一次创建对象

      const AIEntry = {
        _id: _id,
        dataId: dataId,
        loading: true,
        hideInUI: false,
        obj: "AI",
        value: [
          {
            type: "text",
            text: {
              content: this.contentBuffer
            }
          }
        ],
        customFeedbacks: [],
        time: new Date().toISOString()
      };
      this.messages.push(AIEntry);


      // 发送消息后启用自动滚动并滚动到底部
      this.autoScrollEnabled = true;
      this.$nextTick(() => {
        this.scrollToBottom(true);
      });

      this.draft = ""
      this.toConnect()
    },
    // 关闭加载状态
    closeLoading() {
      const idx = this.messages.findIndex(item => item._id === this.currentId);

      if (idx !== -1) {
        this.$set(this.messages, idx, {
          ...this.messages[idx],
          loading: false
        });
      }
    },
    // 处理 SSE 事件消息
    handleEventMessage(event) {
      console.log('Received data:', event.data);

      try {
        const parsed = JSON.parse(event.data);
        if (parsed.event === 'finishedEnd') {
          // 更新已有对象
          this.closeLoading()
          this.loadStatus = true
          this.closeConnect()
          // setEventSource(null);  // 清空保存的实例
          return
        }

        if (parsed.event != "answer" && parsed.event != "fastAnswer") return;

        // 拼接 delta.content
        if (parsed.choices && Array.isArray(parsed.choices)) {
          parsed.choices.forEach(choice => {
            if (choice.delta) {
              const text = choice.delta.content;
              if (text) {
                this.contentBuffer += text;
              }
            }
          });
        }
        if (this.contentBuffer == "") return;

        // 更新已有对象
        const idx = this.messages.findIndex(item => item._id === this.currentId);
        if (idx !== -1) {
          this.$set(this.messages, idx, {
            ...this.messages[idx],
            value: [
              {
                type: "text",
                text: {
                  content: this.contentBuffer
                }
              }
            ]
          });
        }


      } catch (err) {
        console.error("解析 SSE 数据失败:", err);
      }

      // 每次更新消息内容后都尝试滚动到底部
      this.$nextTick(() => {
        this.scrollToBottom();
      });
    },
    // 关闭 SSE 连接
    closeConnect() {
      if (this.eventSource) {
        this.closeLoading()

        this.eventSource.close();  // 关闭 EventSource 连接
        this.contentBuffer = "";
        this.currentId = null;
        this.dataId = null;
        this.loading = false

      }
      ajax.Get({
        url: `/api/ai/hlxj/sse/closeConnect?clientId=${this.id || '15132452294'}`
      }).then(res => {
        if (res.status >= 200 && res.status < 300) {
          console.log('SSE连接已关闭');
          console.log("this.message", this.message)
          this.loadStatus = true
        } else {
          console.error('关闭SSE连接失败:', res.statusText);
        }
      })


    },
    // 处理滚动事件
    handleScroll() {
      const container = this.$refs.chatList;
      if (!container) return;
      this.savedScrollTop = container.scrollTop;
      const distanceToBottom = container.scrollHeight - (container.scrollTop + container.clientHeight);
      this.autoScrollEnabled = distanceToBottom <= 5;
    },
    // 滚动到底部
    scrollToBottom(force = false) {
      const container = this.$refs.chatList;
      if (!container) return;
      if (force || this.autoScrollEnabled) container.scrollTop = container.scrollHeight;
    },
    // 提取消息内容
    getMsg(msg) {

      return (msg?.value?.filter(v => v.type === "text") || [])
        .map(obj => obj.text?.content || "")
        .filter(Boolean)
        .join("\n\n"); // 单换行，避免产生过多 <p>
    },
    // Markdown -> 安全 HTML
    mdToHtml(markdown) {
      if (!markdown) return "";

      // 数学公式处理（保持换行，只压缩空格）
      const processMathFormulas = (content) => {
        // 行间公式
        content = content.replace(/\$\$([\s\S]*?)\$\$/g, (match, formula) => {
          const cleanFormula = formula
            .replace(/\\times/g, "×")
            .replace(/\\mathrm\{([^}]+)\}/g, "$1")
            .replace(/\\text\{([^}]+)\}/g, "$1")
            .replace(/\\/g, "")
            .replace(/[ ]+/g, " ")
            .trim();
          return `<div class="math-block">${cleanFormula}</div>`;
        });

        // 行内公式
        // eslint-disable-next-line no-useless-escape
        content = content.replace(/\$([^\$]+)\$/g, (match, formula) => {
          const cleanFormula = formula
            .replace(/\\times/g, "×")
            .replace(/\\mathrm\{([^}]+)\}/g, "$1")
            .replace(/\\text\{([^}]+)\}/g, "$1")
            .replace(/\\/g, "")
            .replace(/[ ]+/g, " ")
            .trim();
          return `<span class="math-inline">${cleanFormula}</span>`;
        });

        return content;
      };

      // 保留单换行（把单 \n 转成 markdown 的换行语法 "  \n"）
      const preserveLineBreaks = (content) => {
        return content.replace(/([^\n])\n(?!\n)/g, '$1  \n');
      };

      // step1: 处理公式
      let processedMd = processMathFormulas(markdown);

      // step2: 保留 ~ 符号
      processedMd = processedMd.replace(/(\S)~(\S)/g, '$1&#126;$2');

      // step3: 保留单换行
      processedMd = preserveLineBreaks(processedMd);

      // step4: 自定义渲染器
      const renderer = new marked.Renderer();

      // 链接渲染（引用处理）
      renderer.link = (href, title, text) => {
        if (/^\w+$/.test(href)) {
          const citeIdMatch = text.match(/\w+/);
          const citeId = citeIdMatch ? citeIdMatch[0] : text;
          const dataId = this.findDataIdByCiteId(citeId);
          return `<span style="color: deepskyblue; cursor: pointer;" class="cite-tag" data-cite="${citeId}" data-dataid="${dataId || ''}">💭</span>`;
        } else {
          return `<a href="${href}" target="_blank">${text}</a>`;
        }
      };

      // 代码渲染（去掉 <p>，避免多余空行）
      renderer.code = (code) => {
        return `<div class="code-block">${code}</div>`;
      };

      // step5: 解析 & 过滤
      try {
        const rawHtml = marked.parse(processedMd, { renderer });
        return DOMPurify.sanitize(rawHtml, {
          ADD_ATTR: ["data-cite", "data-dataid"],
        });
      } catch (error) {
        console.error("Markdown解析错误:", error);
        return markdown;
      }
    }
    ,
    // 查找包含 citeId 的消息的 dataId
    findDataIdByCiteId(citeId) {
      // 遍历所有消息，查找包含该 citeId 的消息
      for (let i = this.messages.length - 1; i >= 0; i--) {
        const msg = this.messages[i];
        // if (msg.obj === 'AI' && msg.value) {
        const content = this.getMsg(msg);
        // 检查消息内容中是否包含该 citeId
        if (content && content.includes(`[${citeId}](CITE)`)) {
          return msg.dataId;
        }
        // }
      }
      return null;
    },
    // 处理窗口大小变化
    handleResize() {
      const bottomContainer = document.querySelector(".bottom-container");
      // 当前可视高度 vs 视口高度
      const visibleHeight = window.innerHeight;
      const vh = document.documentElement.clientHeight;

      if (visibleHeight < vh) {
        // 键盘弹起，抬高输入框
        bottomContainer.style.bottom = vh - visibleHeight + 15 + "px"; // 10px 可调
      } else {
        bottomContainer.style.bottom = "15px";
      }
    },
  },
  // 组件销毁时移除事件监听
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
    // 组件销毁时关闭 SSE 连接
    if (this.eventSource) {
      this.eventSource.close();
    }


    const container = this.$refs.chatList;
    if (container) {
      container.removeEventListener("scroll", this.handleScroll);
    }
  },
};
</script>

<style scoped>
html {
  font-size: 12px;
}

div,
p,
ul,
li,
* {
  box-sizing: border-box;
}


.chat-container {
  height: calc(100vh - 86px);
  overflow: auto;
  box-shadow: inset 0px 0.5px 0px 0px rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(10px);
  /* padding-bottom: 5vh; */
  /* 给底部输入框留空 */
}

.chat-box {
  padding: 16px;
}

.cite-tag {
  display: inline-block;
  background: #ffeb3b;
  padding: 2px 6px;
  border-radius: 4px;
  cursor: pointer;
  color: dodgerblue;
}

/* 固定在底部的输入框 */

.bottom-container {
  position: fixed;
  bottom: 15px;
  /* 默认底部间距 */
  left: 0;
  right: 0;
  padding: 8px;
  background: #fff;
  height: auto;
  z-index: 1000;
}

.chat-input {
  display: flex;
  box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.05), 0px -2px 3px 0px rgba(51, 51, 51, 0.05);
  border-radius: 12px;
  border: 2px solid #FBB13D;
}

.chat-input input {
  flex: 1;
  border: none;
  padding: 6px 10px;
  outline: none;
  box-shadow: 0px 2px 4px 0px rgba(51, 51, 51, 0.05), 0px -2px 4px 0px rgba(51, 51, 51, 0.05);
  border-radius: 10px;
  height: 40px;
}

.chat-input button {
  margin-left: 8px;
  padding: 6px 12px;
  background: #FBB13D;
  color: #fff;
  border: none;
  border-radius: 4px;
}

.tj {
  margin-right: 10px;
  width: 100px;
  height: 30px;
  line-height: 30px;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  font-style: normal;
  margin-bottom: 10px;
  border-radius: 8px;
  border: 1px solid #E4E4E4;
}

.loading-dots {
  display: flex;
  gap: 4px;
  align-items: center;
  margin-bottom: 10px;
}

.loading-dots span {
  width: 6px;
  height: 6px;
  background: #666;
  border-radius: 50%;
  display: inline-block;
  animation: blink 1.4s infinite both;
}

.loading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.loading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes blink {

  0%,
  80%,
  100% {
    transform: scale(0);
    opacity: 0.3;
  }

  40% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
